/**
 * Get minimum of two Int32 values
 *
 * @param {import('./Int32Type.js').BrandedInt32} a - First value
 * @param {import('./Int32Type.js').BrandedInt32} b - Second value
 * @returns {import('./Int32Type.js').BrandedInt32} Minimum value
 */
export function minimum(a, b) {
	return /** @type {import('./Int32Type.js').BrandedInt32} */ (a < b ? a : b);
}
